import { html } from 'lit';
import { BlocksElement } from '../BlocksElement';
import styles from './grid-item.styles';
/**
 * @slot default - The content of the grid item
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksGridItem extends BlocksElement {
    static { this.styles = styles; }
    render() {
        const componentClassName = this.componentClassNames('cat-c-grid__item', {});
        return html `
      <div part="base" class="${componentClassName}">
        <slot part="part-default"></slot>
      </div>
    `;
    }
}
if (customElements.get('cat-grid-item') === undefined) {
    customElements.define('cat-grid-item', BlocksGridItem);
}
